import React from 'react';

import ctaBgImage from '../../assets/img/img-cta-section.webp';

interface CtaSectionProps {
  handleScheduleClick: () => void;
}

const CtaSection: React.FC<CtaSectionProps> = ({
  handleScheduleClick
}) => {
  return (
    <section className="relative py-24 bg-cover bg-center overflow-hidden" style={{ backgroundImage: `url(${ctaBgImage})` }}>
      <div className="absolute inset-0 bg-[#1e2f4f]/78"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(255,255,255,0.16),transparent_40%),radial-gradient(circle_at_80%_70%,rgba(163,190,238,0.2),transparent_46%)]"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h2 className="text-3xl md:text-5xl font-semibold mb-5">Se você sente que é hora de cuidar de você, esse pode ser o começo</h2>
        <p className="text-lg md:text-2xl mb-2">"Conheça todas as teorias, domine todas as técnicas, mas ao tocar uma alma humana, seja apenas outra alma humana."</p>
        <p className="text-base mb-10 text-white/85">Carl Gustav Jung</p>
        <a 
          href="#contato" 
          onClick={handleScheduleClick}
          className="inline-flex items-center justify-center bg-white text-[#1f2f4c] font-semibold px-8 py-4 rounded-lg hover:bg-[#eef3ff] transition duration-300 shadow-[0_12px_40px_rgba(0,0,0,0.25)]"
        >
          Agendar consulta agora
        </a>
      </div>
    </section>
  );
};

export default CtaSection;

